import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Button, Typography } from '@mui/material';

import styled from '@emotion/styled';

import { Plan } from '../../pages/SubscriptionPlans/types';
import { PlusIcon } from '../Dialogs/CollabsFilters/ToolTip';

type Props = {
  totalReservations: number;
  plan: Plan;
};

export const BusinessMonthlyReservationLimit: React.FC<Props> = ({
  totalReservations = 0,
  plan,
}) => {
  return (
    <Container>
      <Box display={'flex'} alignItems={'center'} gap={4.5}>
        <Limit>{totalReservations}</Limit>
        <Box>
          <Typography sx={{ fontSize: '18px', color: '#232832', fontWeight: 600 }}>
            Monthly reservations
          </Typography>
          <Typography sx={{ color: '#1A1C1E', fontSize: '15px' }}>
            {!plan
              ? 'Get more traffic and more reservations — upgrade to starter or PLUS '
              : plan === 'starter'
                ? 'Get featured placement in app— upgrade to PLUS'
                : plan === 'plus'
                  ? 'Your business gets maximum visibility in the app!'
                  : null}
          </Typography>
        </Box>
      </Box>

      {plan !== 'plus' && (
        <Button
          component={Link}
          variant='contained'
          color='primary'
          sx={{ fontSize: '15px', fontWeight: 500, px: 1.5, py: 1.3 }}
          startIcon={<PlusIcon sx={{ height: '20px', width: '20px' }} />}
          to='/plans'
        >
          {!plan ? 'Get more traffic' : plan === 'starter' ? 'Get featured placement' : null}
        </Button>
      )}
    </Container>
  );
};

const Container = styled.div<{ maxWidth?: string }>`
  border-radius: 8px;
  border: 1px solid #f3f3f3;
  background-color: #fafafa;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 22px 28px;
  max-width: 100%;
`;

const Limit = styled.h1`
  color: #232832;
  font-family: Poppins;
  font-size: 40px;
  font-weight: 600;
  margin: 0;
  padding: 0;
`;
